const decorators = {};

// Basic control option is visible only for Active & Hitech types
decorators.decorateType = (state, action) => {
  const { payload } = action;
  let { path } = payload;
  if (typeof path === "string") {
    path = path.split("/");
  }
  const [target, prop] = path || [];
  const value = state[target].state[prop];

  if (value === "active" || value === "hitech") {
    state.tractor.property.topic.options = state.tractor.property.topic.options.map(
      (topic) =>
        topic.value === "basicControl" ? { ...topic, disabled: false } : topic
    );
  } else {
    state.tractor.state.basicControl = false;
    state.tractor.property.topic.options = state.tractor.property.topic.options.map(
      (topic) =>
        topic.value === "basicControl" ? { ...topic, disabled: true } : topic
    );
  }
};

decorators.decorateCompareObject = (compareObject, state) => {
  const tractorState = state?.context?.tractor?.state || {};

  // Oveton versio tavallisella sisustalla -> M219VV2550307
  compareObject.M219VV2550307 =
    !tractorState.twoDoor && !tractorState.premiumInterior;

  // Oveton versio Premium sisustalla -> M219VV2550307_premium
  compareObject.M219VV2550307_premium =
    !tractorState.twoDoor && tractorState.premiumInterior;

  // Ovellinen versio tavallisella sisustalla -> M219VV2550308
  compareObject.M219VV2550308 =
    tractorState.twoDoor && !tractorState.premiumInterior;

  // Ovellinen versio premium sisustalla -> M219VV2550310
  compareObject.M219VV2550310 =
    tractorState.twoDoor && tractorState.premiumInterior;

  // Twintrack + premium, Kuskin puoleinen C Pilari -> M219VV2550304
  compareObject.M219VV2550304 =
    tractorState.twintrack && tractorState.premiumInterior;

  // Twintrack + tavallinen, Kuskin puoleinen C Pilari -> M219VV2550302
  compareObject.M219VV2550302 =
    tractorState.twintrack && !tractorState.premiumInterior;

  // Ilman twintrackia, premium sisustalla C pilari -> M219VV2550301_premium
  compareObject.M219VV2550301_premium =
    !tractorState.twintrack && tractorState.premiumInterior;

  // Ilman twintrackia, tavallisella sisustalla C pilari -> M219VV2550301
  compareObject.M219VV2550301 =
    !tractorState.twintrack && !tractorState.premiumInterior;

  // Twintrack + premium, kaukalomatto -> M219VV2550110
  compareObject.M219VV2550110 =
    tractorState.twintrack && tractorState.premiumInterior;

  // Ilman twintrackia, premium sisustalla Kaukalomatto -> M219VV2550109
  compareObject.M219VV2550109 =
    !tractorState.twintrack && tractorState.premiumInterior;

  // Twintrack + premium, katteet -> M219VV2550402_Premium
  compareObject.M219VV2550402_Premium =
    tractorState.twintrack && tractorState.premiumInterior;

  // Twintrack + tavallinen, katteet -> M219VV2550402
  compareObject.M219VV2550402 =
    tractorState.twintrack && !tractorState.premiumInterior;

  // Twintrack + premium, ratin muovit -> M121VV2595101_Premium
  compareObject.M121VV2595101_Premium =
    tractorState.twintrack && tractorState.premiumInterior;

  // Twintrack + tavallinen, ratin muovit -> M121VV2595101
  compareObject.M121VV2595101 =
    tractorState.twintrack && !tractorState.premiumInterior;

  // Coolbox + Premium -> M219VV2598552_Premium
  compareObject.M219VV2598552_Premium =
    tractorState.coolbox && tractorState.premiumInterior;

  // Coolbox + Tavallinen -> M219VV2598552
  compareObject.M219VV2598552 =
    tractorState.coolbox && !tractorState.premiumInterior;

  // Twintrack + Premium -> M219VV2550401_Premium Piiloon
  compareObject.M219VV2550401_Premium =
    !tractorState.twintrack && tractorState.premiumInterior;

  // Basiccontrol + Premium, sisustan muovi -> M121VV2550265_Premium
  compareObject.M121VV2550265_Premium =
    (tractorState.type === "active" || tractorState.type === "hitech") && tractorState.basicControl && tractorState.premiumInterior;

  // Premium interior + hitech tai active + basic control false
  compareObject.M121VV2550254_Premium =
    (tractorState.type === "active" || tractorState.type === "hitech") && !tractorState.basicControl && tractorState.premiumInterior;

  // Basiccontrol + Tavallinen, sisustan muovi -> M121VV2550265
  compareObject.M121VV2550265 =
    tractorState.basicControl && !tractorState.premiumInterior;

  //  Basiccontrol + Premium, kahvan muovit -> M121VV2564614_Premium
  compareObject.M121VV2564614_Premium =
    tractorState.basicControl && tractorState.premiumInterior;

  //  Basiccontrol + tavallinen, kahvan muovit -> M121VV2564614_Premium
  compareObject.M121VV2564614 =
    tractorState.basicControl && !tractorState.premiumInterior;

  // Basiccontrol + Premium -> M219VV2564416_Premium Piiloon
  compareObject.M219VV2564416_Premium =
    (tractorState.type === "active" || tractorState.type === "hitech") && !tractorState.basicControl && tractorState.premiumInterior;

  compareObject.spot11 = tractorState.type !== "direct";

  return compareObject;
};

export default decorators;
